import React from 'react'

import { Box, Skeleton } from '@mui/material'
import { useCustomerContactsQuota } from 'features/customers/hooks/useCustomerContactsQuota'

import { quotaSeverity } from 'components/_base/QuotaUsage'

type CustomerContactsLimitProps = {
  customerId: string
}

// The usage answer carries the limit: the feature value before the switch, the ledger's after.
const CustomerContactsLimit = ({ customerId }: CustomerContactsLimitProps) => {
  const { data: quota, isPending, isError } = useCustomerContactsQuota(customerId)

  if (isPending) {
    return <Skeleton variant="text" width={85} />
  }

  if (isError || !quota) {
    return '—'
  }

  if (quota.total === undefined) {
    return '∞ / ∞'
  }

  const severity = quotaSeverity(quota.total, quota.used)

  return (
    <Box component="span" sx={{ color: severity ? `${severity}.main` : undefined }}>
      {quota.used}&thinsp;/&thinsp;{quota.total}
    </Box>
  )
}

export default CustomerContactsLimit
